import React from 'react';
import { Box, Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const TransformationArrayField = ({
  transformations,
  setTransformations,
  renderField,
  headers,
  disableForm,
  errors,
  getNewTransform,
  hideAddButton = false,
}) => {
  const addTransformation = () => {
    const newTransform = getNewTransform
      ? getNewTransform()
      : {
          sourceColumns: [''],
          outputColumn: '',
          transformInPlace: false,
        };
    setTransformations([...transformations, newTransform]);
  };

  const removeTransformation = (index) => {
    if (transformations.length <= 1) return;
    const newTransforms = [...transformations];
    newTransforms.splice(index, 1);
    setTransformations(newTransforms);
  };

  return (
    <Box>
      {transformations?.map((transform, index) => (
        <Box
          key={index}
          sx={{
            mb: 3,
            p: 2,
            border: '1px solid #ddd',
            borderRadius: 1,
            position: 'relative',
          }}
        >
          {transformations.length > 1 && (
            <IconButton
              onClick={() => removeTransformation(index)}
              disabled={disableForm}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}

          {renderField({ transform, index, headers, disableForm, errors: errors?.[index] || {} })}
        </Box>
      ))}

      {!hideAddButton && (
        <Button
          variant="outlined"
          onClick={addTransformation}
          disabled={disableForm}
          startIcon={<AddIcon />}
          sx={{ mt: 1 }}
        >
          Add Column Transformation
        </Button>
      )}
    </Box>
  );
};
export default TransformationArrayField;
